import React, { Component } from 'react';
import * as Styles from './Styles';
import DateSelect from './DateSelect';
import SvgArrowDown from '../../../../others/svg_dist/ArrowDown';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../../../core/Store';
import * as FormManager from '../../../../reducers/ui/form';
import HoverPopover, { POSITION } from '@react_components/hover_popover';

type State = {};

class TermComponent extends Component<PropsFromRedux, State> {
	state = {};

	render() {
		return (
			<Styles.Wrapper id="form-stage1-term">
				<Styles.TopFontContainer>
					{this.props.error && (
						<HoverPopover
							content={<span>{this.props.error}</span>}
							position={POSITION.TOP}
						>
							<Styles.StyledSvgInfo />
						</HoverPopover>
					)}
					<Styles.TopFont>
						wskaż dzień rozpoczęcia ubezpieczenia
					</Styles.TopFont>
				</Styles.TopFontContainer>
				<Styles.BottomContainer>
					<Styles.DateFont>
						ubezpieczenie <span>będzie obowiązywać od:</span>
					</Styles.DateFont>
					<DateSelect
						value={this.props.selectedStartDate}
						setValue={(date) => this.props.setStartDate(date)}
					/>
					<Styles.DecorContainer>
						<SvgArrowDown />
					</Styles.DecorContainer>
					<Styles.DateFont>
						ubezpieczenie będzie obowiązywać do:
					</Styles.DateFont>
					<DateSelect
						value={this.props.selectedEndDate || ''}
						setValue={(date) => {}}
						disabled
					/>
				</Styles.BottomContainer>
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({
		selectedStartDate: FormManager.Selectors.getStartDate(state),
		selectedEndDate: FormManager.Selectors.getEndDate(state),
		error: FormManager.Selectors.getTermError(state),
	}),
	(dispatch) => ({
		setStartDate: (date: string) =>
			dispatch(FormManager.Actions.setStartDate(date)),
	})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const Term = connector(TermComponent);
export default Term;
